import React from 'react';
import styled from 'styled-components';
import { IconProps } from './types';

const PaybackIcon = (props: IconProps): JSX.Element => (
  // allow prop spreading for svg icon
  // eslint-disable-next-line
  <svg viewBox="0 0 323.2 323.2" {...props}>
    <path
      className="st0"
      d="M55.3,323.1C24.8,323.1,0,298.4,0,267.9V55.3C0,24.8,24.8,0,55.3,0h212.6c30.5,0,55.3,24.8,55.3,55.3v212.6
      c0,30.5-24.8,55.3-55.3,55.3H55.3z"
    />
    <g>
      <path
        className="st1"
        d="M303.3,267.9c0,19.6-15.9,35.4-35.4,35.4H55.3c-19.6,0-35.4-15.9-35.4-35.4V55.3c0-19.6,15.9-35.4,35.4-35.4
        h212.6c19.6,0,35.4,15.9,35.4,35.4V267.9z"
      />
    </g>
    <g>
      <path
        className="st0"
        d="M94.2,65.9c-15.7,0-28.3,12.7-28.3,28.3c0,15.7,12.7,28.3,28.3,28.3c15.7,0,28.3-12.7,28.3-28.3
        C122.6,78.6,109.9,65.9,94.2,65.9 M94.3,118.7c-13.5,0-24.4-10.9-24.4-24.5c0-13.5,10.9-24.4,24.4-24.4c13.5,0,24.4,10.9,24.4,24.4
        C118.7,107.8,107.7,118.7,94.3,118.7"
      />
      <path
        className="st0"
        d="M161.6,65.9c-15.7,0-28.3,12.7-28.3,28.3c0,15.7,12.7,28.3,28.3,28.3c15.7,0,28.3-12.7,28.3-28.3
        C189.9,78.6,177.2,65.9,161.6,65.9 M161.6,118.7c-13.5,0-24.4-10.9-24.4-24.5c0-13.5,10.9-24.4,24.4-24.4
        c13.5,0,24.4,10.9,24.4,24.4C186,107.8,175.1,118.7,161.6,118.7"
      />
      <path
        className="st0"
        d="M228.9,65.9c-15.7,0-28.3,12.7-28.3,28.3c0,15.7,12.7,28.3,28.3,28.3c15.7,0,28.3-12.7,28.3-28.3
        C257.2,78.6,244.6,65.9,228.9,65.9"
      />
      <path
        className="st0"
        d="M94.2,200.6c-15.7,0-28.3,12.7-28.3,28.3c0,15.7,12.7,28.3,28.3,28.3c15.7,0,28.3-12.7,28.3-28.3
        C122.6,213.2,109.9,200.6,94.2,200.6 M94.3,253.3c-13.5,0-24.4-10.9-24.4-24.5c0-13.5,10.9-24.4,24.4-24.4
        c13.5,0,24.4,10.9,24.4,24.4C118.7,242.4,107.7,253.3,94.3,253.3"
      />
      <path
        className="st0"
        d="M161.6,200.6c-15.7,0-28.3,12.7-28.3,28.3c0,15.7,12.7,28.3,28.3,28.3c15.7,0,28.3-12.7,28.3-28.3
        C189.9,213.2,177.2,200.6,161.6,200.6 M161.6,253.3c-13.5,0-24.4-10.9-24.4-24.5c0-13.5,10.9-24.4,24.4-24.4
        c13.5,0,24.4,10.9,24.4,24.4C186,242.4,175.1,253.3,161.6,253.3"
      />
      <path
        className="st0"
        d="M228.9,200.6c-15.7,0-28.3,12.7-28.3,28.3c0,15.7,12.7,28.3,28.3,28.3c15.7,0,28.3-12.7,28.3-28.3
        C257.2,213.2,244.6,200.6,228.9,200.6"
      />
      <path
        className="st0"
        d="M94.2,133.2c-15.7,0-28.3,12.7-28.3,28.3c0,15.7,12.7,28.3,28.3,28.3c15.7,0,28.3-12.7,28.3-28.3
        C122.6,145.9,109.9,133.2,94.2,133.2 M94.3,186c-13.5,0-24.4-10.9-24.4-24.4c0-13.5,10.9-24.4,24.4-24.4
        c13.5,0,24.4,10.9,24.4,24.4C118.7,175.1,107.7,186,94.3,186"
      />
      <path
        className="st0"
        d="M161.6,133.2c-15.7,0-28.3,12.7-28.3,28.3c0,15.7,12.7,28.3,28.3,28.3c15.7,0,28.3-12.7,28.3-28.3
        C189.9,145.9,177.2,133.2,161.6,133.2"
      />
      <path
        className="st0"
        d="M228.9,133.2c-15.7,0-28.3,12.7-28.3,28.3c0,15.7,12.7,28.3,28.3,28.3c15.7,0,28.3-12.7,28.3-28.3
        C257.2,145.9,244.6,133.2,228.9,133.2"
      />
    </g>
  </svg>
);

const StyledPaybackIcon = styled(PaybackIcon)`
  width: ${({ size = '1rem' }) => size};
  height: ${({ size = '1rem' }) => size};
  vertical-align: middle;
  .st0 {
    fill: #ffffff;
  }
  .st1 {
    fill: #0046aa;
  }
`;
export default StyledPaybackIcon;
